class Video {
  constructor() {
    const playButton = Array.prototype.slice.call(document.querySelectorAll('.lc-video__thumbnail-container'));
    playButton.forEach(button => {
      button.addEventListener('click', () => {
        const video = button.parentElement;
        const thumbnail = button.querySelector('.lc-video__thumbnail');
        const iframe = video.querySelector('iframe');

        const htmlvideo = video.querySelector('video');

				if(iframe.src.includes('youtube')){
          iframe.src = iframe.src + '?autoplay=1';
        } else if(iframe) {
					iframe.src = iframe.src + '&autoplay=1';
				} else if(video) {
					htmlvideo.play();
				}

				button.style.display = 'none';
        thumbnail.style.display = 'none';
      });
    });
  }
} export default Video;
